import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { css, Global } from "@emotion/core";
import SignupForm from "./Signup/Form";

import { SignupPage1, SignupPage2, SignupPage3 } from "./Signup/Intro";
import Success, { Failure } from "./Signup/Complete";

import Apply from "./Apply";
import Modal from './components/Modal';

import { exposeCookies } from "./Signup/Form/apiCalls";
import {
    populateAndPushDataLayerForGoogleAnalytics,
    sendRouteChangeToGoogleAnalytics,
    useTracking,
} from "./utils/Tracking";
import ExcelPage from "./ExcelValidator/ExcelPage";

function App() {
    useEffect(() => {
        async function fetchCookiesAndSendGAData() {
            await exposeCookies();
            populateAndPushDataLayerForGoogleAnalytics();
            sendRouteChangeToGoogleAnalytics("/");
        }
        fetchCookiesAndSendGAData();
    }, []);

    useTracking();

    return (
        <div className="App">
            <Modal />
            <Global
                styles={css`
                    @font-face {
                        font-family: Modelica;
                        src: url(https://cdn-prod.mytutor.co.uk/fleet/fonts/BwModelica-Medium.otf?1551307291000);
                    }
                    @font-face {
                        font-family: Modelica;
                        src: url(https://cdn-prod.mytutor.co.uk/fleet/fonts/BwModelica-Bold.otf?1551307291000);
                        font-weight: bold;
                    }
                    .App {
                        height: 100vh;
                    }
                    h1,
                    h2,
                    button,
                    a {
                        font-family: "Source Sans Pro", "Lato", -apple-system,
                            BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
                            "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
                            "Helvetica Neue", sans-serif;
                    }
                    body {
                        font-family: "Source Sans Pro", "Lato", -apple-system,
                            BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
                            "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
                            "Helvetica Neue", sans-serif;
                    }
                    html {
                        box-sizing: border-box;
                    }
                    *,
                    *:before,
                    *:after {
                        box-sizing: inherit;
                    }
                `}
            />
            <Switch>
                <Route path="/signup/form" component={SignupForm} />
                <Route path="/signup/1" component={SignupPage1} />
                <Route path="/signup/2" component={SignupPage2} />
                <Route path="/signup/3" component={SignupPage3} />
                <Route path="/signup/complete/success" component={Success} />
                <Route path="/signup/complete/error" component={Failure} />
                <Route path="/secure/apply" component={Apply} />
                <Route
                    exact
                    path="/schools/form-checker"
                    component={ExcelPage}
                />
                <Route
                    exact
                    path="/schools/form-checker-group"
                    component={ExcelPage}
                />
                <Route
                    path="/tutors/schools/form-checker"
                    component={() => (
                        <Redirect
                            to={{
                                pathname: "/schools/form-checker",
                            }}
                            push
                        />
                    )}
                />
                <Route
                    path="/tutors/schools/form-checker-group"
                    component={() => (
                        <Redirect
                            to={{
                                pathname: "/schools/form-checker-group",
                            }}
                            push
                        />
                    )}
                />
                <Route
                    path="/"
                    component={({ location }) => (
                        <Redirect
                            to={{
                                ...location,
                                pathname: "/signup/1",
                            }}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}

export default App;
